import {
  Grid,
  MenuItem,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Card } from "../../ui/Card";
import { StyledSeperator } from "../../ui/Seperator";
import { useReturns } from "./dashboardApi";
import { NoDataFound } from "../../../common/NoDataFound";
import useDashboardShipmentFilter, {
  PaymentData,
} from "./useDashboardShipmentFilter";
import DatePickerEl from "../../ui/DatePickerEl";
import { Dayjs } from "dayjs";

const Returns = () => {
  const {
    paymentMode,
    serviceMode,
    startDate,
    endDate,
    indexOfPayment,
    indexOfService,
    handlePaymentChange,
    handleDateChange,
    handleServiceFilter,
    serviceData,
  } = useDashboardShipmentFilter();

  console.log(serviceMode);

  const { data: returnsData } = useReturns(
    PaymentData[indexOfPayment].filter,
    startDate as Dayjs,
    endDate as Dayjs,
    serviceData?.[indexOfService] as string
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Stack
          direction={"row"}
          justifyContent={"flex-end"}
          alignItems={"center"}
          marginBottom={"40px"}
          flexWrap={"wrap"}
        >
          <Stack
            direction={"row"}
            justifyContent={"center"}
            alignItems={"center"}
            columnGap={"40px"}
            rowGap={"30px"}
            flexWrap={"wrap"}
          >
            <DatePickerEl
              defaultDate={startDate}
              handleChange={(time) => handleDateChange(time, "start")}
              label="From"
            />
            <DatePickerEl
              defaultDate={endDate}
              handleChange={(time) => handleDateChange(time, "end")}
              label="To"
            />
            <Select
              sx={{
                width: "200px",
              }}
              size="small"
              value={paymentMode}
              onChange={handlePaymentChange}
            >
              {PaymentData.map((el, index) => {
                return (
                  <MenuItem key={index} value={el.field}>
                    {el.field}
                  </MenuItem>
                );
              })}
            </Select>
            <Select
              sx={{
                width: "200px",
              }}
              size="small"
              value={serviceMode ?? "Fedex"}
              onChange={handleServiceFilter}
            >
              {serviceData?.map((el, index) => {
                return (
                  <MenuItem key={index} value={el}>
                    {el}
                  </MenuItem>
                );
              })}
            </Select>
          </Stack>
        </Stack>
      </Grid>
      <Grid item sm={4} xs={12} md={12 / 7}>
        <Card>
          <Stack
            direction={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Typography fontSize={"14px"} fontWeight={"600"}>
              Delivered
            </Typography>
            <StyledSeperator
              style={{
                margin: "10px",
                width: "100%",
              }}
            />

            <Typography fontSize={"24px"} fontWeight={"600"}>
              {returnsData?.delivered ?? 0}
            </Typography>
          </Stack>
        </Card>
      </Grid>
      <Grid item sm={4} xs={12} md={12 / 7}>
        <Card>
          <Stack
            direction={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Typography fontSize={"14px"} fontWeight={"600"}>
              Exception
            </Typography>
            <StyledSeperator
              style={{
                margin: "10px",
                width: "100%",
              }}
            />

            <Typography fontSize={"24px"} fontWeight={"600"}>
              {returnsData?.exception ?? 0}
            </Typography>
          </Stack>
        </Card>
      </Grid>
      <Grid item sm={4} xs={12} md={12 / 7}>
        <Card>
          <Stack
            direction={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Typography fontSize={"14px"} fontWeight={"600"}>
              In Transit
            </Typography>
            <StyledSeperator
              style={{
                margin: "10px",
                width: "100%",
              }}
            />

            <Typography fontSize={"24px"} fontWeight={"600"}>
              {returnsData?.in_transit ?? 0}
            </Typography>
          </Stack>
        </Card>
      </Grid>
      <Grid item sm={4} xs={12} md={12 / 7}>
        <Card>
          <Stack
            direction={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Typography fontSize={"14px"} fontWeight={"600"}>
              Pickup Scheduled
            </Typography>
            <StyledSeperator
              style={{
                margin: "10px",
                width: "100%",
              }}
            />

            <Typography fontSize={"24px"} fontWeight={"600"}>
              {returnsData?.pickup_scheduled ?? 0}
            </Typography>
          </Stack>
        </Card>
      </Grid>
      <Grid item sm={4} xs={12} md={12 / 7}>
        <Card>
          <Stack
            direction={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Typography fontSize={"14px"} fontWeight={"600"}>
              Pickup Unscheduled
            </Typography>
            <StyledSeperator
              style={{
                margin: "10px",
                width: "100%",
              }}
            />

            <Typography fontSize={"24px"} fontWeight={"600"}>
              {returnsData?.pickup_unscheduled ?? 0}
            </Typography>
          </Stack>
        </Card>
      </Grid>
      <Grid item sm={4} xs={12} md={12 / 7}>
        <Card>
          <Stack
            direction={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Typography fontSize={"14px"} fontWeight={"600"}>
              Return Percentage
            </Typography>
            <StyledSeperator
              style={{
                margin: "10px",
                width: "100%",
              }}
            />

            <Typography fontSize={"24px"} fontWeight={"600"}>
              {returnsData?.return_percentage ?? 0}
            </Typography>
          </Stack>
        </Card>
      </Grid>
      <Grid item sm={4} xs={12} md={12 / 7}>
        <Card>
          <Stack
            direction={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Typography fontSize={"14px"} fontWeight={"600"}>
              Total Return
            </Typography>
            <StyledSeperator
              style={{
                margin: "10px",
                width: "100%",
              }}
            />

            <Typography fontSize={"24px"} fontWeight={"600"}>
              {returnsData?.total_return ?? 0}
            </Typography>
          </Stack>
        </Card>
      </Grid>
      <Grid item xs={12}>
        <TableContainer component={Card}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Total Orders</TableCell>
                <TableCell>Pickup Unscheduled</TableCell>
                <TableCell>Pickup Scheduled</TableCell>
                <TableCell>In Transit</TableCell>
                <TableCell>Exception</TableCell>
                <TableCell>Cancelled</TableCell>
                <TableCell>Delivered</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {returnsData &&
                returnsData.return_count?.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row?.date}</TableCell>
                    <TableCell>{row?.total_orders}</TableCell>
                    <TableCell>{row?.pickup_unscheduled}</TableCell>
                    <TableCell>{row?.pickup_scheduled}</TableCell>
                    <TableCell>{row?.in_transit}</TableCell>
                    <TableCell>{row?.exception}</TableCell>
                    <TableCell>{row?.cancelled}</TableCell>
                    <TableCell>{row?.delivered}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          <NoDataFound data={returnsData?.return_count ?? []} />
        </TableContainer>
      </Grid>
    </Grid>
  );
};

export default Returns;
